<template>
  <div>
    <cards-list :notShowAddButton="false" />
    <iban-list :notShowAddButton="!showSepa" />
  </div>
</template>

<script>
import { getAvailablePayments } from '@/services/CartService';
import CardsList from './CardsList.vue';
import IbanList from './IbanList.vue';

export default {
  components: {
    CardsList,
    IbanList,
  },

  data() {
    return {
      paymentMethods: [],
    };
  },

  computed: {
    showSepa() {
      if (this.paymentMethods.length > 0 && this.paymentMethods.find((method) => method.slug === 'sepa')) {
        return true;
      }
      return false;
    },
  },

  created() {
    this.getPaymentMethods();
  },

  methods: {
    getPaymentMethods() {
      getAvailablePayments().then(({ data }) => {
        this.paymentMethods = [];
        this.paymentMethods = data;
      });
    },
  },

};
</script>
